import { Apis } from "../network/apis";
import { Eole } from "@syadem/eole";
import { GetVaccinationCertificateQuery } from "./getVaccinationCertificateQuery";
import { GetCitizenCalendarQuery } from "./getCitizenCalendarQuery";
import { AppStore } from "../store";
import { GetPublicConfigsQuery } from "./getPublicConfigsQuery";

export interface Queries {
  getVaccinationCertificate: GetVaccinationCertificateQuery;
  getCitizenCalendar: GetCitizenCalendarQuery;
  getPublicConfigs: GetPublicConfigsQuery;
}

export const initQueries = ({ apis, eole, store }: { apis: Apis; eole: Eole; store: AppStore }): Queries => {
  return {
    getVaccinationCertificate: new GetVaccinationCertificateQuery(apis.kairosCertApi),
    getCitizenCalendar: new GetCitizenCalendarQuery(eole, store),
    getPublicConfigs: new GetPublicConfigsQuery(eole, store),
  };
};
